import {call, put, select} from 'redux-saga/effects'
import {selectors} from '../reservation'
import {defineTypes} from '../../helpers'

const kegTypes = {...defineTypes('KEG_TYPES')}

function* selectKegError() {
  yield put({type: kegTypes.FAILURE, errors: [{"error": 'Please select a keg type and size'}]})
  throw {"error": ['Please select a beer type and keg size']}
}

function* getKegs() {
  const number_of_kegs = yield select(selectors.number_of_kegs)
  var kegs = []
  let i = 0
  while (i < number_of_kegs) {
    const keg_size = yield select(selectors.selected_keg_size, i)
    if (keg_size && keg_size['value'] && keg_size['value']['type'] === 'keg_size') {
      const product = yield select(selectors.selected_product, i)
      let keg_size_id = keg_size['value'] && keg_size['value']['id']
      let product_id = product && product['value'] && product['value']['id']
      let inventory_type = product && product['value'] && product['value']['inventory_type']
      keg_size_id && product_id
        ? kegs.push({
          'keg_size_id': keg_size_id,
          'product_id': product_id,
          'inventory_type': inventory_type
        })
        : yield call(selectKegError)
      yield i++
    } else {
      let inventory_type = keg_size['inventory_type']
      let inventory_id = keg_size && keg_size['value'] && keg_size['value']['id']
      inventory_id
        ? kegs.push({
          'inventory_id': keg_size['value']['id'],
          'inventory_type': inventory_type
        })
        : yield call(selectKegError)
      yield i++
    }
  }
  return kegs.length < 1
    ? yield call(selectKegError)
    : kegs
}

export function* buildReservation() {
  const number_of_kegs = yield select(selectors.number_of_kegs)
  const kegs = yield* getKegs()
  const hand_taps = yield select(selectors.hand_taps)
  const pick_up_date = yield select(selectors.pick_up_date)
  const location = yield select(selectors.location)
  var keg_form = {
    hand_taps: hand_taps,
    pick_up_date: pick_up_date,
    kegs: kegs,
    number_of_kegs: number_of_kegs,
    location_id: location && location.value
  }
  return keg_form
}



// WEBPACK FOOTER //
// ./src/sagas/helpers/reservation_helpers.js